import type { VoidFunctionComponent } from 'react';
import Loader from '../../../generic/Loader';
import Card from '../../../generic/Card/Card';
import Flex from '../../../generic/Flex';
import {
  getCurrentPlanType,
  isBusinessPlan,
  isEnterprisePlan,
  isFreePlan,
  planIcon,
} from '../utils';
import styles from './styles.module.less';
import FullFeatureTable from './featuresTable';
import { window } from '../../../../globals';
import { usePlansContext } from './PlansContext';
import PlansHeaderComponent from './PlansHeader';
import DisplayBusinessPlan from './DisplayBusinessPlan';
import DisplayFreePlan from './DisplayFreePlan';
import DisplayEnterprisePlan from './DisplayEnterprisePlan';

export type ViewIntervalOptions = 'month' | 'year';

const Plans: VoidFunctionComponent = () => {
  const {
    plans,
    isLoading,
  } = usePlansContext();

  if (isLoading) {
    return (<Loader />);
  }

  if (!plans) {
    return null;
  }

  const org = window?.user?.organization;
  if (!org) {
    return null;
  }
  const currentPlanType = getCurrentPlanType(org);

  return (
    <>
      <PlansHeaderComponent />
      <Flex direction="row" align="unset" gap={32}>
        {plans.map((plan) => {
          const isFree = isFreePlan(plan.product);
          const isBusiness = isBusinessPlan(plan.product);
          const isEnterprise = isEnterprisePlan(plan.product);
          return (
            <Flex direction="row" align="unset" key={plan.product.name}>
              <Card
                isFullWidth
                isContentFullHeight
                variant="fill"
                key={plan.product.name}
              >
                <Card.Content>
                  <div className={styles.cardContentContainer}>
                    <Flex direction="column" align="flex-start" justify="flex-start" gap={20}>
                      <img src={planIcon(plan.product)} alt={plan.product.name} />

                      <div className={styles.planName}>
                        {plan.product.name}
                      </div>

                      <div className={styles.planDescription}>
                        {plan.product.description}
                      </div>
                      {isFree && <DisplayFreePlan />}
                      {isBusiness && <DisplayBusinessPlan />}
                      {isEnterprise && <DisplayEnterprisePlan />}
                    </Flex>
                  </div>
                </Card.Content>
              </Card>
            </Flex>
          );
        })}
      </Flex>

      <FullFeatureTable currentPlanType={currentPlanType} />
    </>
  );
};

export default Plans;
